import { useEffect, useState } from "react";
import styles from "./roundedButton.module.scss";
import Link from "next/link";
import { svgImages } from "@/lib/svgImages";
import { appendAttributionBridgeParams } from "@/lib/dashboard-urls";
const RoundedButton = ({
  title,
  url,
  withIcon = true,
  light,
  fill = false,
  fullWidth = false,
  target = "",
  menoHover = false,
}) => {
  const [currentUrl, setCurrentUrl] = useState("/");

  useEffect(() => {
    // Update URL after component mounts to ensure client/server match
    const normalized = url?.replace(/\/$/, "") || "/";
    setCurrentUrl(appendAttributionBridgeParams(normalized));
  }, [url]);

  // useEffect(() => {
  //   const btn = document.querySelector(`${styles["btn"]}`);
  //   const handleMouseMove = (e) => {
  //     const x = e.clientX - btn.offsetLeft;
  //     const y = e.clientY - btn.offsetTop;

  //     btn.style.setProperty("--x", `${x}px`);
  //     btn.style.setProperty("--y", `${y}px`);
  //   };

  //   document.addEventListener("mousemove", handleMouseMove);

  //   return () => {
  //     document.removeEventListener("mousemove", handleMouseMove);
  //   };
  // }, []);

  return (
    <div
      className={`${styles["roundedButton"]} ${
        light === true ? styles["light"] : ""
      } ${fill === true ? styles["fill"] : ""}
      ${menoHover === true ? styles["menoHover"] : ""}
      ${fullWidth === true ? styles["full"] : ""}
      `}
    >
      <Link
        href={currentUrl}
        className={`${styles["btn"]}`}
        prefetch={false}
        target={target}
      >
        <span>{title}</span>
        {withIcon && (
          <span dangerouslySetInnerHTML={{ __html: svgImages.arrowRight }} />
        )}
      </Link>
    </div>
  );
};

export default RoundedButton;
